import { render } from "./GridComponent.vue?vue&type=template&id=35494c81&scoped=true&ts=true"
import script from "./GridComponent.vue?vue&type=script&lang=ts"
export * from "./GridComponent.vue?vue&type=script&lang=ts"

import "./GridComponent.vue?vue&type=style&index=0&id=35494c81&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35494c81"]])

export default __exports__